import React from 'react';

import Chip from 'components/Chip';

import { AuditStatus, AuditStatusNames } from 'core/constants';

import { colors } from 'theme/colors';

// Label as well as colour, so the status isn't colour-only (a11y); no state falls back to In progress, as the backend does.
const AuditStatusChip: React.FunctionComponent<{ status: AuditStatus | null | undefined }> = ({
  status,
}): React.ReactElement => {
  const submitted = status === AuditStatus.Submitted;

  return (
    <Chip
      label={submitted ? AuditStatusNames[AuditStatus.Submitted] : AuditStatusNames[AuditStatus.InProgress]}
      colors={{
        background: submitted ? colors.ui.status.completed : colors.ui.status.inProgress,
      }}
    />
  );
};

export default AuditStatusChip;
